import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { richT } from "@thelabnyc/thelabui/src/utils/richText";

import { Link } from "../../../components/Link";
import { WebPageURL } from "../../../models/nominals";
import { formatPhoneNumber } from "../../../utils/format";
import { UnifiedOrderLookupShippingAddress } from "../types";

import defaultStyles from "./index.module.scss";

type TrackShipmentDetailsCustomerInfoProps = Immutable<{
    shippingAddress: UnifiedOrderLookupShippingAddress;
    customerLoginURL: WebPageURL;
    customerRegisterURL: WebPageURL;
    customStyles?: CSSModuleClasses;
}>;

export const TrackShipmentDetailsCustomerInfo: React.FC<
    TrackShipmentDetailsCustomerInfoProps
> = ({
    shippingAddress,
    customerLoginURL,
    customerRegisterURL,
    customStyles,
}) => {
    const isRedacted = shippingAddress.line1 === "XXXXX";
    const styles = customStyles || defaultStyles;

    return (
        <div>
            <h3 className={styles.title}>{t`Delivery Information`}</h3>
            {isRedacted ? (
                <div>
                    <p className={styles.copy}>
                        {richT(
                            t`<login>Login</login> to view your delivery address, payment information, and order history.`,
                            {
                                login: (children) => (
                                    <Link
                                        className={styles.link}
                                        href={customerLoginURL}
                                    >
                                        {children}
                                    </Link>
                                ),
                            },
                        )}
                    </p>
                    <p className={styles.copy}>
                        {richT(
                            t`Don't have an account? <signup>Create one</signup>`,
                            {
                                signup: (children) => (
                                    <Link
                                        className={styles.link}
                                        href={customerRegisterURL}
                                    >
                                        {children}
                                    </Link>
                                ),
                            },
                        )}
                    </p>
                </div>
            ) : (
                <address className={styles.address}>
                    <div>
                        {shippingAddress.line1} {shippingAddress.line2}
                    </div>
                    <div>
                        {shippingAddress.line3} {shippingAddress.line4}
                        {", "}
                        {shippingAddress.state}
                    </div>
                    <div>
                        {shippingAddress.postcode}
                        {", "}
                        {shippingAddress.country}
                    </div>
                </address>
            )}
            <p className={styles.copy}>
                {formatPhoneNumber(shippingAddress.phone_number)}
            </p>
        </div>
    );
};
